import Adults from '../../resources/onboardig/Adults.png';
import AdultsSelected from '../../resources/onboardig/AdultsSelected.png';
import Children from '../../resources/onboardig/Children.png';
import ChildrenSelected from '../../resources/onboardig/ChildrenSelected.png';
import MeSelected from '../../resources/onboardig/MeSelected.png';
import Me from '../../resources/onboardig/Me.png';

const Questions = {
  items: [
    {
      key: 1,
      question: 'Which of these reminds you of your home internet?',
      description:
        'This’ll help us get you the Wi-Fi speed you’re paying for. We’ll also see if your hardware and network settings are up-to-date.',
      singleChoice: false,
      answered: false,
      choices: [
        {
          key: 0,
          answer: 'It sometimes stops working. I don’t know why.',
          selected: false,
        },
        {
          key: 1,
          answer: 'It’s too slow.',
          selected: false,
        },
        {
          key: 2,
          answer: 'I’m not sure if there’s a problem with it.',
          selected: false,
        },
        {
          key: 3,
          answer: 'I wonder if my Wi-Fi is safe and secure.',
          selected: false,
        },
      ],
    },
    {
      key: 2,
      question: 'Who shares your home?',
      description:
        'A full-house can bring on a higher chance of accidents. No worries though, we’ve got you covered with repairs, replacements, and support like setting up parental controls and more.',
      singleChoice: false,
      answered: false,
      choices: [
        {
          key: 0,
          activePng: AdultsSelected,
          inactivePng: Adults,
          answer: 'Adult humans (besides me)',
          selected: false,
        },
        {
          key: 1,
          activePng: ChildrenSelected,
          inactivePng: Children,
          answer: 'Children',
          selected: false,
        },
        {
          key: 2,
          activePng: MeSelected,
          inactivePng: Me,
          answer: 'Just me',
          selected: false,
        },
      ],
    },
    {
      key: 3,
      question: 'How comfortable are you using the technology in your home?',
      description:
        "Most people live with at least one device that isn't being used to its full potential. We can easily and quickly help you use all of your devices.",
      singleChoice: true,
      answered: false,
      choices: [
        {
          key: 0,
          answer: 'I don’t know what I’m doing.',
          selected: false,
        },
        {
          key: 1,
          answer: 'It works, but I find it confusing.',
          selected: false,
        },
        {
          key: 2,
          answer: 'I think I’ve got this.',
          selected: false,
        },
        {
          key: 3,
          answer: 'I feel like I’m an expert.',
          selected: false,
        },
      ],
    },
    {
      key: 4,
      question: 'How do you feel about streaming entertainment?',
      description:
        'When you stream entertainment like movies, shows and sports, you get to choose what you want to watch, when you want to watch it. We’ll help you navigate your options.',
      singleChoice: true,
      answered: false,
      choices: [
        {
          key: 0,
          answer: 'I don’t know what streaming is, but I’m interested in learning.',
          selected: false,
        },
        {
          key: 1,
          answer: 'I stream entertainment, but I find it confusing.',
          selected: false,
        },
        {
          key: 2,
          answer: 'I’d like to understand my options better.',
          selected: false,
        },
        {
          key: 3,
          answer: 'I’m happy with the way things are.',
          selected: false,
        },
      ],
    },
    {
      key: 5,
      question: 'How comfortable are you using the internet?',
      description:
        'Enjoy the benefits of using the internet, while staying as secure as possible. We’ll show you how to set privacy settings on social media like Facebook and manage your passwords for email and more.',
      singleChoice: false,
      answered: false,
      choices: [
        {
          key: 0,
          answer: 'I’d like guidance to secure and manage passwords.',
          selected: false,
        },
        {
          key: 1,
          answer: 'I’d like a review of my social site settings.',
          selected: false,
        },
        {
          key: 2,
          answer: 'I want to increase the security of key accounts.',
          selected: false,
        },
        {
          key: 3,
          answer: 'I’m all good.',
          selected: false,
        },
      ],
    },
  ],
};

export default Questions;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/pages/onboarding/questionData.js